/**
 * WISHLIST FILE TECHNIC
 * 
 * module de gestion des création 
 * de la documentation technique de wishlist
 * via une popin dans
 * la partie PRO de l'espace mon compte
 */
import $ from "jquery";
import { debounce } from 'throttle-debounce';
const utils = require('../utils.js').default;
import { strings } from "../../../../helpers/strings.js";
import { services } from "../../../../helpers/service";
import { dialog } from '../../../../components/dialog.js';
const WLFileTechnic = (() => {

    const POPIN_FILE_TECH_WISHLIST = 'popin-file-technic';
    const DOM_POPIN_FILE_TECH_WISHLIST = `[data-js-dialog-id="${POPIN_FILE_TECH_WISHLIST}"]`;
    const POPIN_FILE_TECH_WAITING_DOWNLOAD = 'popin-file-technic-waiting-download';
    const DOM_POPIN_FILE_TECH_WAITING_DOWNLOAD = `[data-js-dialog-id="${POPIN_FILE_TECH_WAITING_DOWNLOAD}"]`;
    const OPENER_POPIN_FILE_TECH_WISHLIST = `.js-file-technic-popin-opener`;

    const FT_DOCS_TYPE_LIST                 = `${DOM_POPIN_FILE_TECH_WISHLIST} .js-docs-type-list`;
    const FT_DOCS_TYPE_LIST_ELEMENTS        = `${FT_DOCS_TYPE_LIST} input`;
    const FT_FILE_TECHNIC_TABLE             = `${DOM_POPIN_FILE_TECH_WISHLIST} .js-file-technic-table tbody`;
    const FT_FILE_TECHNIC_TABLE_ELEMENTS    = `${FT_FILE_TECHNIC_TABLE} tr`;
    const FT_FORM                           = `${DOM_POPIN_FILE_TECH_WISHLIST} .js-wishlist-tech-file`;
    const FT_REF_SELECTED                   = `${DOM_POPIN_FILE_TECH_WISHLIST} .js-ref-selected`;
    const FT_REF_TOTAL                      = `${DOM_POPIN_FILE_TECH_WISHLIST} .js-ref-total`;
    const FT_DOCS_SELECTED_TOTAL            = `${DOM_POPIN_FILE_TECH_WISHLIST} .js-docs-selected-total`;
    const FT_DOCS_SELECTED_TOTAL_WEIGHT     = `${DOM_POPIN_FILE_TECH_WISHLIST} .js-docs-weight-total`;
    const FT_FILE_TECHNIC_PRODUCT           = `${DOM_POPIN_FILE_TECH_WISHLIST} .js-file-technic-product input`;
    const FT_SUBMIT                         = `${DOM_POPIN_FILE_TECH_WISHLIST} .js-file-technic-submit`;
    const FT_DOWNLOAD_LIMIT_WEIGHT          = `${DOM_POPIN_FILE_TECH_WISHLIST} .js-weight-wrapper strong`;
    const FT_MAIL_CHECKBOX                  = `${DOM_POPIN_FILE_TECH_WISHLIST} .js-envoi-mail`;
    const FT_MAIL_INPUT                     = `${DOM_POPIN_FILE_TECH_WISHLIST} .js-input-email`;
    const FT_ERROR                          = `${DOM_POPIN_FILE_TECH_WISHLIST} .js-form-error`;
    const FT_REPCAPTCHA                     = `${DOM_POPIN_FILE_TECH_WISHLIST} #g-recaptcha`;
    
    
    const DOWNLOAD_LIMIT_WEIGHT = 100;
    const FT_ERROR_LOAD_DETAILS_PRODUCTS = 'Une erreur est survenue pendant le chargement des données du dossier technique.';
    const FT_ERROR_DOWNLOAD_FILE_TECHNIC = 'Une erreur est survenue pendant le téléchargement de votre dossier technique.';
    const FT_ERROR_CAPTCHA = 'Une erreur est survenue avec le service de REPCATCHA.'


    let fileTechnicData = [];
    let documentationsData = [];
    let downloadLimitReach = false;

    /**
     * DOCS LIST ELEMENTS SELECTION CHANGE
     * 
     * 
     * @param {event} event 
     */
    const docsListElementsSelectionChange = (event) => {
        event.preventDefault();
        let elem = $(event.currentTarget);
        let type = elem.val();
        fileTechnicData.forEach((product) => {
            product.documentation.filter((doc) => doc.slug === type)[0].enable = elem.prop('checked');
        });
        updates();
    };
    /**
     * FILE TECHNIC WISHLIST SUBMIT
     * 
     * formatage/serialization du form
     * création via service du fichier technique
     * @param {event} event 
     * @returns 
     */
    const fileTechnicWishlistSubmit = (event) => {
        event.preventDefault();
        let form = $(FT_FORM).clone();
        // si envoi par email checked
        if ($(FT_MAIL_CHECKBOX).prop('checked')) {
            $(DOM_POPIN_FILE_TECH_WAITING_DOWNLOAD).attr('data-file-technique-send','mail');
        } else {
            $(DOM_POPIN_FILE_TECH_WAITING_DOWNLOAD).attr('data-file-technique-send','download');
            form.find("#email").remove();
        }

        let xhrData = form.serializeArray();
        xhrData.push({ name: "context", value: utils.getContext() });
        // on enregistre tous les paramêtres à ON
        var options = xhrData.filter(function(el) {
            // on vérifie la présence des données et l'activation
            return el.name === 'doc_family[]' && typeof el.value !== 'undefined'
        }).map(function(el) {
            // on formalise les résultats
            return strings.snakeCase(el.value)
        });
        utils.dispatchCustomEvent('TRACKERS_DOWNLOAD_TECHNICAL_DOCUMENTS', {options});
        $(`${DOM_POPIN_FILE_TECH_WAITING_DOWNLOAD} .c-loader`).attr('aria-hidden', false);
        $(`${DOM_POPIN_FILE_TECH_WAITING_DOWNLOAD} .js-icon-validation`).addClass("u-hidden");
        dialog.close(POPIN_FILE_TECH_WISHLIST);
        dialog.open(POPIN_FILE_TECH_WAITING_DOWNLOAD);
        return services.use('wishlisttechfile', xhrData)
            .then((result) => {
                if (result.error !== undefined && result.error === "captchaerror") {
                    utils.dispatchCustomEvent('TEMPLATE_ERROR', {error:FT_ERROR_CAPTCHA});
                } else {
                    utils.debug('WL FILE TECHNIC WISHLIST SUBMIT', result.datas);   
                    $(`${DOM_POPIN_FILE_TECH_WAITING_DOWNLOAD} .c-loader`).attr('aria-hidden', true);
                    $(`${DOM_POPIN_FILE_TECH_WAITING_DOWNLOAD} .js-icon-validation`).removeClass("u-hidden");

                    if ($(`${DOM_POPIN_FILE_TECH_WAITING_DOWNLOAD}`).attr('data-file-technique-send') === 'mail') return;
                    if (!result.datas) return;
                    if (result.datas.file) {
                        location.href = result.datas.file;
                    } else {
                        utils.download(result.datas.filename, result.datas.content)
                    }
                }
            })
            .catch((error) => {
                utils.dispatchCustomEvent('TEMPLATE_ERROR', {error:FT_ERROR_DOWNLOAD_FILE_TECHNIC});
            });
    };
    /**
     * GENERATE DOCS TYPE LIST
     * 
     * génératio via template de la liste
     * des types de fichiers technique
     * @returns 
     */
    const generateDocsTypeList = () => {
        $(FT_DOCS_TYPE_LIST).empty();
        if (documentationsData.length === 0) {
            $(FT_ERROR).slideDown();
            return;
        }
        documentationsData.forEach((doc) => {
            if (doc.docsCount !== 0) {
                utils.dispatchCustomEvent('TEMPLATE_COMMON_PART', {
                    append: true,
                    templateId: 'tpl-file-technic-docs-type-list-input',
                    targetElement: FT_DOCS_TYPE_LIST,
                    data: {
                        docSlug: doc.slug,
                        docName: doc.name,
                    }
                });
            }
        });
    };
    /**
     * GENERATE FILE TECHNIC
     * 
     * génération de la popin fil technic
     * via service. 
     * init des events et templates
     * @param {event} event 
     * @returns 
     */
    const generateFileTechnic = (event) => {
        utils.dispatchCustomEvent('LOADER');
        event.preventDefault();
        let productsIds = window.WL.getFlattenProductsIds();
        let context = utils.getContext();
        let datas = { eans: productsIds, size: true, context};
        fileTechnicData = [];
        documentationsData = [];
        $(FT_ERROR).attr('aria-hidden', true);
        return services.use('wishlistdetailtechfile', datas)
            .then((data) => {
                parseData(data.datas.elements);
                generateDocsTypeList();
                generateProductsTable();
                updates();
                $(FT_FILE_TECHNIC_PRODUCT).on('change', productSelectionChange);
                $(FT_DOCS_TYPE_LIST_ELEMENTS).on('change', docsListElementsSelectionChange);
                $(FT_MAIL_CHECKBOX).on('change', updateMail);
                $(DOM_POPIN_FILE_TECH_WISHLIST).addClass('active');
                $(FT_MAIL_INPUT).on('keyup change', debounce(500, function() {
                    updateSubmitButton();
                }));
                $(FT_SUBMIT).unbind().on('click', fileTechnicWishlistSubmit);
                utils.dispatchCustomEvent('LOADER');
                dialog.open(POPIN_FILE_TECH_WISHLIST);
            }).catch((error) => {
                // console.log(error);
                utils.dispatchCustomEvent('TEMPLATE_ERROR', {error:FT_ERROR_LOAD_DETAILS_PRODUCTS});
            });
    };
    /**
     * GENERATE PRODUCTS TABLE
     * 
     * génération du tableau de fichiers
     * @returns 
     */
    const generateProductsTable = () => {
        $(FT_FILE_TECHNIC_TABLE).empty();
        if (fileTechnicData.length === 0 ) {
            $(FT_ERROR).slideDown();
            return;
        }
        fileTechnicData.forEach((product) => {
            utils.dispatchCustomEvent('TEMPLATE_COMMON_PART', {
                append: true,
                templateId: 'tpl-file-technic-table-product',
                targetElement: FT_FILE_TECHNIC_TABLE,
                data: {
                    ean: product.ean,
                    name: product.label,
                    agrementCount: getDocParam(product.documentation, 'agrement', 'value'),
                    catCount: getDocParam(product.documentation, 'catalogue', 'value'),
                    noticeCount: getDocParam(product.documentation, 'notice', 'value'),
                    pepCount: getDocParam(product.documentation, 'pep', 'value'),
                    ficheCount: getDocParam(product.documentation, 'fiche', 'value'),
                    guideCount: getDocParam(product.documentation, 'guide', 'value'),
                    disabled: product.docsCount > 0 ? '' : 'disabled="disabled"', //
                    totalCount: product.docsCount || '0',
                    totalWeight: getFormatedFileWeight(product.docsWeight || 0),
                }
            });
        });
    };
    /**
     * PARSE DATA
     * 
     * construction de l'objet de données
     * @param {object} data 
     */
    const parseData = (data) => {
        data.forEach((element) => {
            element.docsWeight = 0;
            element.docsCount = 0;
            element.selected = true;
            for (const key in element.documentation) {
                if (Object.hasOwnProperty.call(element.documentation, key)) {
                    const doc = element.documentation[key];
                    doc.slug = key;
                    doc.enable = doc.value > 0 ? true : false;
                    element.docsWeight += doc.size;
                    element.docsCount += doc.value;

                    if (documentationsData.filter(elem => elem.slug === doc.slug).length) {
                        documentationsData.filter(elem => elem.slug === doc.slug)[0].docsCount += doc.value;
                    } else {
                        documentationsData.push({'slug': doc.slug, 'docsCount': doc.value, 'name': doc.key});
                    }
                }
            }
            element.documentation = Object.values(element.documentation);
        })
        fileTechnicData = data;
    };
    /**
     * PRODUCT SELECTION CHANGE
     * 
     * update de l'object fileTechnicData 
     * après la selection/déselection d'une ref produit
     * @param {event} event 
     */
    const productSelectionChange = (event) => {
        event.preventDefault();
        let elem = $(event.currentTarget);
        fileTechnicData.filter(product => product.ean === elem.val())[0].selected = elem.prop('checked');
        updates();
    };
    /**
     * UPDATES
     * 
     * updates des différentes parties du fichier technique
     */
    const updates = () => {
        updateProductsInformations();
        updateTotalSelectedRefs();
        updateTotalSelectedRefsWeight();
        updateTotalSelectedDocumentations();
        updateSubmitButton();
        updateMail();
    };
    /**
     * UPDATE MAIL
     * 
     * show/hide du champ d'email
     */
    const updateMail = () => {
        if ($(FT_MAIL_CHECKBOX).prop('checked')) {
            $(FT_MAIL_INPUT).parent().slideDown();
        } else {
            $(FT_MAIL_INPUT).parent().slideUp();
        }
        updateSubmitButton();
    };
    /**
     * UPDATE PRODUCTS INFORMATIONS
     * 
     * updates de la liste ref products
     */
    const updateProductsInformations = () => {
        fileTechnicData.forEach((product) => {
            product.docsWeight = 0;
            product.docsCount = 0;
            product.documentation.forEach((doc) => {
                if (doc.enable) {
                    product.docsWeight += doc.size;
                    product.docsCount += doc.value;
                }
            });
            if (product.docsCount === 0) {
                // disabled product
                product.selected = false;
                $(`${FT_FILE_TECHNIC_TABLE_ELEMENTS}[data-ean="${product.ean}"]`)
                    .addClass('disabled').find('input')
                        .prop('disabled', true)
                        .prop('checked', false);
            } else {
                $(`${FT_FILE_TECHNIC_TABLE_ELEMENTS}[data-ean="${product.ean}"]`)
                    .removeClass('disabled').find('input')
                        .prop('disabled', false);
            }
            $(`${FT_FILE_TECHNIC_TABLE_ELEMENTS}[data-ean="${product.ean}"] .js-doc-count`).text(product.docsCount);
            $(`${FT_FILE_TECHNIC_TABLE_ELEMENTS}[data-ean="${product.ean}"] .js-doc-weight`).html(getFormatedFileWeight(product.docsWeight));
        })
    };
    /**
     * UPDATE SUBMIT BUTTON
     * 
     * update du button de submit enabled/disabled
     */
    const updateSubmitButton = () => {
        let selectedProducts = fileTechnicData.filter((product) => product.selected === true).length;
        let disabledSubmit = false;
        let validEmail = utils.validateEmail($(FT_MAIL_INPUT).val());
        if (!selectedProducts) {
            disabledSubmit = true;
        }
        if ($(FT_MAIL_CHECKBOX).prop('checked') && !validEmail) {
            disabledSubmit = true;
        }
        $(FT_SUBMIT).prop('disabled', disabledSubmit);
    };
    /**
     * UPDATE TOTAL SELECTED DOCUMENTATIONS
     * 
     * update du champ Nombre de documents sélectionnés
     */
    const updateTotalSelectedDocumentations = () => {
        $(FT_DOCS_SELECTED_TOTAL).text(getTotalSelectedDocumentations());
    };
    /**
     * UPDATE TOTAL SELECTED REFS WEIGHT
     * 
     * update du champ Poids total des fichiers sélectionnés
     * gestion de la limite du poid
     *  - affichage message
     *  - input envoi par mail auto checked
     */
    const updateTotalSelectedRefsWeight = () => {
        let totalSelectedDocumentationsWeight = getFormatedFileWeight(getTotalSelectedDocumentationsWeight());
        $(FT_DOCS_SELECTED_TOTAL_WEIGHT).html(totalSelectedDocumentationsWeight);
        if (parseInt(totalSelectedDocumentationsWeight) > DOWNLOAD_LIMIT_WEIGHT) {
            downloadLimitReach = true;
            $(FT_DOWNLOAD_LIMIT_WEIGHT).removeClass('u-hidden').slideDown();
            $(FT_MAIL_CHECKBOX).prop('disabled', true).prop('checked', true);
        } else {
            downloadLimitReach = false;
            $(FT_DOWNLOAD_LIMIT_WEIGHT).slideUp();
            $(FT_MAIL_CHECKBOX).prop('disabled', false);
        }
    };
    /**
     * UPDATE TOTAL SELECTED REFS
     * 
     * update du champ Nombre de référence(s) sélectionnée(s)
     */
    const updateTotalSelectedRefs = () => {
        $(FT_REF_SELECTED).text(getSelectRefs());
        $(FT_REF_TOTAL).text(getTotalRefs());
    };
    // GETTER
    /**
     * GET DOC PARAM
     * 
     * getter d'une valeur de l'object docs
     * @param {object} docs 
     * @param {string} docType 
     * @param {string} value 
     * @returns {string}
     */
    const getDocParam = (docs, docType, value) => {
        return docs.filter(docs => docType === docs.slug)[0][value].toString();
    };
    /**
     * GET FORMATED FILE WEIGHT
     * 
     * formatage poid de fichier
     * @param {number} docsWeight 
     * @returns {string}
     */
    const getFormatedFileWeight = (docsWeight) => {
        return `${utils.getFormatedFileWeight(docsWeight)}&nbsp;Mo`;
    };
    /**
     * GET SELECT REFS
     * 
     * nombre de ref products selected
     * @returns {number}
     */
    const getSelectRefs = () => {
        return fileTechnicData.filter(product => product.selected === true).length;
    };
    /**
     * GET TOTAL REFS
     * 
     * nom total de refs
     * @returns {number}
     */
    const getTotalRefs = () => {
        return fileTechnicData.length;
    };
    /**
     * GET TOTAL SELECTED DOCUMENTATIONS
     * 
     * total des documentations selectionnées
     * par produit selectionné
     * @returns {number}
     */
    const getTotalSelectedDocumentations = () => {
        let totalDocsCount = 0;
        let selectedProducts = fileTechnicData.filter(product => product.selected === true);
        if (selectedProducts.length === 0) return totalDocsCount;
        selectedProducts.forEach((product) => {
            totalDocsCount += product.docsCount;
        });
        return totalDocsCount;
    };
    /**
     * GET TOTAL SELECTED DOCUMENTATIONS WEIGHT
     *
     * poid total des documentations selectionnées
     * par produit selectionné
     * @returns {number}
     */
    const getTotalSelectedDocumentationsWeight = () => {
        let totalDocsWeight = 0;
        let selectedProducts = fileTechnicData.filter(product => product.selected === true);
        if (selectedProducts.length === 0) return totalDocsWeight;
        selectedProducts.forEach((product) => {
            totalDocsWeight += product.docsWeight;
        });
        return totalDocsWeight;
    }
    /**
     * INIT (func)
     */
    const init = () => {
        utils.debug('WL FILE TECHNIC', 'initialisation');  
        $(OPENER_POPIN_FILE_TECH_WISHLIST).on('click', generateFileTechnic);
        
    };
    return {init}
})();
export default WLFileTechnic;